module.exports = __webpack_public_path__ + "static/media/IMG_7429.2f87d859.png";